import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<circle cx="16" cy="16" r="1"/><path d="M16 8a8 8 0 108 8 8 8 0 00-8-8zm5.5 9.8a4.7 4.7 0 01-2.5.9 4.5 4.5 0 01-3-1.3 2.3 2.3 0 00-.1 3 1 1 0 01-.3 1.4 1 1 0 01-.6.2 1 1 0 01-.8-.5 4.4 4.4 0 01.4-5.6 2.4 2.4 0 00-3 0 1 1 0 11-1.1-1.7 4.4 4.4 0 015.6.4 2.4 2.4 0 00.1-3 1 1 0 011.7-1.1 4.4 4.4 0 01-.4 5.6 2.4 2.4 0 003 .1 1 1 0 011.3.3 1 1 0 01-.3 1.3z"/><path d="M28 2H4a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2zM16 26a10 10 0 1110-10 10 10 0 01-10 10z"/>';
export var AirConditioningSVG = function AirConditioningSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
AirConditioningSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(AirConditioningSVG);